export default "__VITE_ASSET__37020473__"